

        jQuery(function() {
            var $module = jQuery('#m-1580858577180');
            
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1577744468566').children('.module');

            var sameHeightTitle = $module.data('sameheightitle'),
                spacing = $module.data('spacing');
                collg = $module.data('collg'),
                colmd = $module.data('colmd'),
                colsm = $module.data('colsm'),
                colxs = $module.data('colxs');

            var $clearfixes = $module.find('.gf_row-no-padding').children('.gf_clearfix');
            var col = collg;


            jQuery(window).resize(function() {
                setTimeout(function() {
                    for(var i = 0; i < $clearfixes.length; i++) {
                        if($clearfixes.eq(i).css('display') == 'block') {
                            if($clearfixes.eq(i).hasClass('visible-lg')) {
                                col = collg;
                                break;
                            }
                            if($clearfixes.eq(i).hasClass('visible-md')) {
                                col = colmd;
                                break;
                            }
                            if($clearfixes.eq(i).hasClass('visible-sm')) {
                                col = colsm;
                                break;
                            }
                            if($clearfixes.eq(i).hasClass('visible-xs')) {
                                col = colxs;
                                break;
                            }
                        }
                    }
                }, 1000);
            });

            if(sameHeightTitle == '1') {
                var minHeight = 0;

                $module.find('.product-single__title').each(function() {
                });
            } else {
            }

            jQuery($module).css('padding', spacing);
        }); 
    
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child1').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child1-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child1-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child2').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child2-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child2-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child3').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child3-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child3-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child4').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child4-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child4-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child5').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child5-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child5-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child6').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child6-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child6-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child7').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child7-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child7-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child8').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child8-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child8-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child9').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child9-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child9-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child10').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child10-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child10-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child11').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child11-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child11-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child12').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child12-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child12-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child13').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child13-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child13-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child14').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child14-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child14-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child15').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child15-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child15-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child16').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child16-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child16-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child17').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child17-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child17-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child18').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child18-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child18-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child19').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child19-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child19-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child20').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child20-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child20-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child21').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child21-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child21-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child22').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child22-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child22-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child23').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child23-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child23-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child24').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child24-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child24-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child25').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child25-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child25-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child26').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child26-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child26-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child27').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child27-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child27-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child28').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child28-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child28-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child29').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child29-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child29-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child30').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child30-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child30-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child31').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child31-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child31-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child32').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child32-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child32-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child33').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child33-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child33-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child34').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child34-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child34-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child35').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child35-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child35-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child36').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child36-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child36-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child37').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child37-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child37-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child38').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child38-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child38-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child39').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child39-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child39-1').children('.module');
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child40').children('.module');
        $module.gfV3Product();
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child40-0').children('.module');
        var effect = $module.attr('data-effect');
        $module.gfV3ProductImage({
            'effect': effect
        })
    });
  
    jQuery(function() {
        var $module = jQuery('#m-1577744468566-child40-1').children('.module');
    });
  
        jQuery(function() {
            var $module = jQuery('#m-1577744468500').children('.module');
            var mode = jQuery('.gryffeditor').hasClass('editing') ? 'dev' : 'production';
            
            if (mode == 'dev') {
                var $paginator = $module.find('.gf_collection-paginator-wrapper');
                if ($paginator.length > 0) {
                    var productCount = $paginator.attr('data-product-count');
                    var previousText = $module.attr('data-previous');
                    var nextText = $module.attr('data-next');
                    var activeColor = $module.attr('data-active-color');      

                    var applyEvents = function() {
                        $paginator.children('span:not(.deco)').off('click').on('click', function() {
                            var currentPage = parseInt($paginator.children('.current').text()) - 1;
                        
                            if (jQuery(this).hasClass('prev')) {
                                currentPage--;
                            } else if (jQuery(this).hasClass('next')) {
                                currentPage++;
                            } else {
                                currentPage = parseInt(jQuery(this).text()) - 1;
                            }
                            render(currentPage);
                        })
                    }

                    var render = function(currentPage) {
                        $paginator.html('');

                        if (currentPage != 0) {
                            $paginator.append('<span class="prev">' + previousText + '</span>')
                        }
                        
                        if (currentPage - 2 > 0) {
                            $paginator.append('<span class="page">1</span>');
                        }

                        if (currentPage -2 > 1) {
                            $paginator.append('<span class="deco">...</span>');
                        }

                        for (var i = Math.max(0, currentPage - 2); i <= Math.min(currentPage + 2, productCount - 1); i++) {
                            $paginator.append('<span class="page' + (currentPage == i ? ' current' : '') + '">' + (i + 1) + '</span>');
                        }

                        if (currentPage + 2 < productCount - 2) {
                            $paginator.append('<span class="deco">...</span>');
                        }

                        if (currentPage + 2 < productCount - 1) {
                            $paginator.append('<span class="page">' + productCount + '</span>');
                        }

                        if (currentPage != productCount - 1 && productCount != 0) {
                            $paginator.append('<span class="next">' + nextText + '</span>')
                        }

                        applyEvents();
                    }

                    render(0);
                }
            }
        });
    
var gemFlag=!1;for(var i=0;i<pageLibs.length;i++){if(pageLibs[i].indexOf('gfv3product.js')!==-1){if(jQuery.gfV3Product==undefined){gemFlag=!0;break}}if(pageLibs[i].indexOf('gfv3restabs.js')!==-1){if(jQuery.gfV3ResTabs==undefined){gemFlag=!0;break}}if(pageLibs[i].indexOf('gfaccordion.js')!==-1){if(jQuery.gfAccordion==undefined){gemFlag=!0;break}}}if(gemFlag){var count=0;for(var i=0;i<pageLibs.length-1;i++){jQuery.getScript(pageLibs[i],function(){count++;if(count==pageLibs.length-1){jQuery.getScript(pageLibs[pageLibs.length-1],function(){})}})}}